import {
  Navigate,
  RouterProvider,
  createBrowserRouter,
} from "react-router-dom";
import AppLayout from "./AppLayout";
import AboutSection from "./Sections/AboutSection";
import SkillsSection from "./Sections/SkillsSection";
import EducationSection from "./Sections/EducationSection";
import ProjectsSection from "./Sections/ProjectsSection";
import ExperienceSection from "./Sections/ExperienceSection";
import { DarkModeProvider } from "./context/DarkModeContext";
import NotFoundPage from "./components/NotFoundPage";

const Router = createBrowserRouter([
  {
    path: "/",
    element: <AppLayout />,
    children: [
      {
        index: true,
        element: <AboutSection />,
      },
      {
        path: "/about",
        element: <Navigate to="/" replace />,
      },
      {
        path: "/skills",
        element: <SkillsSection />,
      },
      {
        path: "/education",
        element: <EducationSection />,
      },
      {
        path: "/projects",
        element: <ProjectsSection />,
      },
      {
        path: "/experience",
        element: <ExperienceSection />,
      },
      {
        path: "*",
        element: <NotFoundPage />,
      },
    ],
  },
]);
export default function App() {
  return (
    <DarkModeProvider>
      <RouterProvider router={Router} />
    </DarkModeProvider>
  );
}
